/**
 * This abstract class is used to extend loggers that will be used.
 * The actual logger can use any framework and if further features
 * are needed just extend this class and the new features.
 * There is a default implementation of timing function that works
 * identically to the function used in js-logger.
 */

import LoggingSource from "./LoggingSource";

export default abstract class BaseLogger {
  private readonly timerStartTimeByLabelMap: { [id: string]: number } = {};

  abstract debug(message: string, loggingSource?: LoggingSource): void;
  abstract info(message: string, loggingSource?: LoggingSource): void;
  abstract warning(message: string, loggingSource?: LoggingSource): void;
  abstract error(message: string, loggingSource?: LoggingSource): void;
  abstract critical(message: string, loggingSource?: LoggingSource): void;

  timeStart(label: string, loggingSource?: LoggingSource) {
    if (loggingSource)
      this.timerStartTimeByLabelMap[label] = new Date().getTime();
    else {
      console.time(label);
    }
  }
  timeEnd(label: string, loggingSource?: LoggingSource) {
    if (loggingSource) {
      console.log(
        `[${loggingSource}] ${label}: ${
          new Date().getTime() - this.timerStartTimeByLabelMap[label]
        } ms`
      );
      delete this.timerStartTimeByLabelMap[label];
    } else {
      console.timeEnd(label);
    }
  }
}
